import { render, staticRenderFns } from "./FormPlace.vue?vue&type=template&id=2947df84&"
import script from "./FormPlace.vue?vue&type=script&lang=js&"
export * from "./FormPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2947df84')) {
      api.createRecord('2947df84', component.options)
    } else {
      api.reload('2947df84', component.options)
    }
    module.hot.accept("./FormPlace.vue?vue&type=template&id=2947df84&", function () {
      api.rerender('2947df84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/place/form/FormPlace.vue"
export default component.exports